import { first, get, noop } from 'lodash'
import React, { KeyboardEvent, useCallback } from 'react'
import { useDropzone } from 'react-dropzone'
import styled from 'styled-components'

import Button from '../Button'

const Wrapper = styled.div``

const DropzoneWrapper = styled.div`
  border: 2px dashed #e3e3e3;
  display: inline-block;
  padding: 10px;
`

type TFilePicker = {
  value?: File
  onChange?: (e: File) => void
}

const FilePicker = (props: TFilePicker): React.ReactElement => {
  const { value, onChange = noop } = props

  const onDrop = useCallback((acceptedFiles: File[]) => {
    if (get(acceptedFiles, 'length', 0) === 1) {
      const file = first(acceptedFiles)
      onChange(file)
    }
  }, [])

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })

  const { onKeyDown: onRootKeyDown, ...restRootProps } = getRootProps()

  const { onKeyDown: onInputKeyDown, ...restInputProps } = getInputProps()

  const fixedRootProps = {
    ...restRootProps,
    onKeyDown: (e: KeyboardEvent<HTMLElement>) => {
      if (typeof onRootKeyDown === 'function') {
        onRootKeyDown(e)
      }
    },
  }

  const fixedInputProps = {
    ...restInputProps,
    onKeyDown: (e: KeyboardEvent<HTMLInputElement>) => {
      if (typeof onInputKeyDown === 'function') {
        onInputKeyDown(e)
      }
    },
  }

  const filename = get(value, 'name')

  return (
    <Wrapper>
      <DropzoneWrapper {...fixedRootProps}>
        <input {...fixedInputProps} />
        <div>
          <Button light>{i18n.t(`search_files`, `Dateien durchsuchen`)}</Button>{' '}
          <span>{i18n.t(`or_drop_here`, `oder hier ablegen`)}</span>
        </div>
        {filename && (
          <div className="mt-2">
            <span>{filename}</span>
          </div>
        )}
      </DropzoneWrapper>
    </Wrapper>
  )
}

export default FilePicker
